import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import Button from '../Button/Button.js';
import { NOOP } from '../../../utils/const.js';
import NavDropdown from '../../NavDropdown/NavDropdown.js';
import MenuUffici from './MenuUffici.js';
import PermIdentityIcon from '../../GoogleIcons/Outlined/PermIdentityIcon.js';
import ExportIcon from '../../GoogleIcons/Outlined/ExportIcon.js';

/**
 * Componente utilizzato per la visualizzazione del menu utente (tipicamente disegnato a destra nella Application bar)
 */
function MenuUtente({ utente, uffici = [], ufficioSelezionato = undefined, onUfficioChange = NOOP, accountsUrl = undefined, myCgnUrl = undefined, onLogout = undefined, children = null, subTitleMenu = undefined, }) {
    const denominazioneUtente = utente ? `${utente.nome} ${utente.cognome}`.toUpperCase() : undefined;
    const urlLogout = accountsUrl ? `${accountsUrl}/home/logout` : '#';
    const gotoProfiloUtente = useCallback(() => {
        var _a;
        (_a = window.open(`${myCgnUrl}/#/ufficio/${ufficioSelezionato}`, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
    }, [myCgnUrl, ufficioSelezionato]);
    const logOut = useCallback(() => {
        window.location.replace(urlLogout);
    }, [urlLogout]);
    const subTitle = subTitleMenu || (ufficioSelezionato ? `Ufficio ${ufficioSelezionato}` : undefined);
    return (jsxs(NavDropdown, { className: "v2-menu-utente", title: denominazioneUtente, subtitle: subTitle, children: [children, jsx(MenuUffici, { uffici: uffici, ufficioSelezionato: ufficioSelezionato, onUfficioChange: onUfficioChange }), uffici && uffici.length > 0 && jsx(MenuUtente.Item, { divider: true }), jsx(MenuUtente.Item, { disabled: !myCgnUrl || !ufficioSelezionato, onClick: gotoProfiloUtente, children: jsxs(Button, { children: [jsx(PermIdentityIcon, {}), ' ', "Profilo personale"] }) }), jsx(MenuUtente.Item, { divider: true }), jsx(MenuUtente.Item, { onClick: () => (onLogout ? onLogout(urlLogout) : logOut()), disabled: !accountsUrl, children: jsxs(Button, { children: [jsx(ExportIcon, {}), ' ', "Esci"] }) })] }));
}
MenuUtente.Item = NavDropdown.Item;

export { MenuUtente as default };
